/**
 * Mobile PDP option rows (e.g. the size cards) scroll sideways. When an
 * option is picked, glide its row so that card sits in the middle and the
 * options either side are in view; on load, start each row on the selected
 * option. Rows that don't overflow (desktop grids) are left alone.
 */
(() => {
  // Not scoped to #product-variants: sticky-product-info.js moves the
  // option blocks out of it after load
  const ROW = '.product-option-wrapper .variant-wrapper';

  /**
   * @param {HTMLInputElement} input
   * @param {ScrollBehavior} behavior
   */
  function centre(input, behavior) {
    const row = input.closest(ROW);
    const card = input.nextElementSibling;
    if (!row || !card || row.scrollWidth <= row.clientWidth) return;

    const rowBox = row.getBoundingClientRect();
    const cardBox = card.getBoundingClientRect();
    const offset = cardBox.left + cardBox.width / 2 - (rowBox.left + rowBox.width / 2);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    row.scrollBy({ left: offset, behavior: reduceMotion ? 'auto' : behavior });
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.type === 'radio' && input.checked) {
      centre(input, 'smooth');
    }
  });

  function centreSelected() {
    document
      .querySelectorAll(`${ROW} input[type="radio"]:checked`)
      .forEach((input) => centre(input, 'auto'));
  }

  // The cart Edit/Overview popup renders its option rows later
  window.centreSelectedOptionRows = centreSelected;

  if (document.readyState === 'complete') {
    centreSelected();
  } else {
    window.addEventListener('load', centreSelected, { once: true });
  }
})();
